module.exports = "/_next/static/images/34bbb700c2c97403599944ab543918c0-nu-card-lg@2x.jpg.webp";